module.exports = ":host .scrollTop__container {\n  position: fixed;\n  bottom: 15px;\n  right: 15px;\n  opacity: 0;\n  transition: all .2s ease-in-out;\n  cursor: default; }\n\n:host .scrollTop--show {\n  opacity: 1;\n  transition: all .2s ease-in-out;\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/scroll-top-button/scroll-top-button.scss
// module id = 9VCV
// module chunks = 12